<template>
  <div class="form-input" :class="{ 'label-white': labelWhite }">
    <div class="label-container">
      <label :for="`form-input-${id}`">{{prompt}}</label>
      <span class="question" @click="e => onClickInfoBtn(e, infoText)" v-if="!!onClickInfoBtn && !!infoText">?</span>
    </div>
    <input
      :type="type"
      :name="id"
      :id="`form-input-${id}`"
      :placeholder="placeholder"
      v-model="inputValue"
      @input="e => onInput(e, inputValue)"
      @change="e => onChange(e, inputValue)"
      @keyup.enter="e => onPressEnter(e, inputValue)"
      @blur="e => onBlur(e, inputValue)"
    />
    <span class="error">{{error}}</span>
    <span class="warning">{{warning}}</span>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    prompt: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    warning: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    labelWhite: {
      type: Boolean,
      default: false,
    },
    onClickInfoBtn: {
      type: Function,
      required: false,
    },
    infoText: {
      type: String,
      required: false,
    },
    onInput: {
      type: Function,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onPressEnter: {
      type: Function,
      default: () => {},
    },
    onBlur: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      touched: false,
      inputValue: '',
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '../_variables';

.form-input {
  width: 100%;

  &.label-white .label-container {
    label {
      color: white;
    }

    .question {
      color: black;
      background-color: white;
    }
  }

  .label-container {
    display: flex;
    flex-wrap: nowrap;

    label {
      font-family: 'Avenir', sans-serif;
      flex: 1;
      display: block;
      margin-top: 0.8em;
      margin-bottom: 0;
      color: black;
      transition: 250ms all;
    }

    .question {
      cursor: pointer;
      display: inline-block;
      color: white;
      background-color: #ec6569;
      width: 1rem;
      height: 1rem;
      border-radius: 0.5rem;
      margin-left: 0.5rem;
      text-align: center;
      border: 0;
      padding: 0;
      font-family: 'Avenir', sans-serif;
      font-size: 14px;
      align-self: flex-end;
    }
  }

  input[type='text'],
  input[type='email'],
  select {
    font-family: 'Avenir', sans-serif;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(102, 100, 108, 0.16);
    background: #ffffff;
    border-radius: 4px;
    padding: 16px;
    margin: 8px 0;
  }

  .error,
  .warning {
    display: block;
    font-size: 0.8em;
  }

  .error {
    color: #c0392b;
  }
  .warning {
    color: #e67e22;
  }
}
</style>
